module.exports = __webpack_public_path__ + "img/21_28.85f32a6d.png";